import { STRENGTHS } from "../../data/resumeData";
import { LuChartLine } from "react-icons/lu";
import { MdOutlinePriceChange } from "react-icons/md";

function Strengths() {
    return (
      <section className="strengths fade-in">
        <h2>Strengths</h2>
        <div className="card">
            <div id="Strengths">
                {STRENGTHS.map((item, index) => (
                    (item.icon === undefined) ?
                        <div key={index}>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </div> :
                        <div key={index}>
                            <h3>{
                            item.icon === 'chart' ?
                                <LuChartLine className="list-icon" title="Price Chart" /> :
                                <MdOutlinePriceChange className="list-icon" title="Price Change" />
                            }{item.title}</h3>
                            <p>{item.description}</p></div>
                ))}
            </div>
        </div>
      </section>
    );
  }
  
  export default Strengths;